import { Injectable } from '@angular/core';
import { CustomHttpResponse, HttpService } from '@docpath/linces-angular-components/common';
import { Observable } from 'rxjs';

import { EndPoints } from '../../../../constants/end-points';
import { AimConfig, ServicesConfig } from '../models/services-config';



@Injectable({
    providedIn: 'root'
})
export class AimHttpService {

    readonly aimrelativeUrl = `${EndPoints.ENDPOINT_AIM}`;

    constructor(
        private readonly httpService: HttpService
    ) {
    }

    getConfig(): Observable<AimConfig> {
        return new Observable(observer => {
            this.httpService.get({
                relativeUrl: `${this.aimrelativeUrl}/${EndPoints.ENDPOINT_AIM_CONFIG}`,
                loading: true,
                suscribe: response => {
                    const config = response.result as unknown as AimConfig;
                    observer.next(config);
                    observer.complete();
                }
            });
        });
    }

    updateConfig(config: ServicesConfig): Observable<void> {
        return new Observable(observer => {
            this.httpService.put(config.aim, {
                relativeUrl: `${this.aimrelativeUrl}/${EndPoints.ENDPOINT_AIM_CONFIG}`,
                loading: true,
                suscribe: () => {
                    observer.next();
                    observer.complete();
                },
                toast: 'services-config.aim.toast.success'
            });
        });
    }

    testConnection(url: string, appToken: string): Observable<CustomHttpResponse> {
        return new Observable(observer => {
            this.httpService.get({
                relativeUrl: `${this.aimrelativeUrl}/${EndPoints.ENDPOINT_AIM_CONNECTION}`,
                queryParameters: { url, appToken },
                suscribe: response => {
                    observer.next(response);
                    observer.complete();
                }
            });
        });
    }

}
